import './QuestionDifficulty.css'

interface Props {
  difficulty: number
}

function QuestionDifficulty({ difficulty }: Props) {
  switch (difficulty) {
    case 1:
      return <span className="QuestionDifficulty--easy">Easy</span>
    case 2:
      return <span className="QuestionDifficulty--medium">Medium</span>
    case 3:
      return <span className="QuestionDifficulty--hard">Hard</span>
    default:
      return null
  }
}

export default QuestionDifficulty
